import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import ServicesScene from "@/components/sections/ServicesScene";
import AboutScene from "@/components/sections/AboutScene";
import ProcessShowcase from "@/components/sections/ProcessShowcase";
import WorkShowcase from "@/components/sections/WorkShowcase";
import ClosingShowcase from "@/components/sections/ClosingShowcase";

export default function Home({ onOpenPalette }: { onOpenPalette: () => void }) {
  return (
    <>
      <Navbar onOpenPalette={onOpenPalette} />
      <main data-testid="home-page" className="page-fade">
        <Hero />
        <ServicesScene />
        <AboutScene />
        <ProcessShowcase />
        <WorkShowcase />
        <ClosingShowcase />
      </main>
      <Footer />
    </>
  );
}
